export default __webpack_public_path__ + "static/media/02_EGEBEFGNGTGAGJGHPU_UB150_K_left_l181107.e005ae0b.jpg";